import React from 'react';
import dosingImg from './img/dosing.png';
import ScaledImg from '../ScaledImg';

interface DosingSectionProps {
  dosing: string;
  setDosing: (dosing: string) => void;
}

const DosingSection: React.FC<DosingSectionProps> = ({ dosing, setDosing }) => {
  return (
    <div>
      <h2>Dosing</h2>
      <ScaledImg src={dosingImg}/>
      <label htmlFor="dosing">Dosing *</label>
      <textarea
        id="dosing"
        value={dosing}
        onChange={(e) => setDosing(e.target.value)}
        required
      />
    </div>
  );
};

export default DosingSection;
